import { createContext, useContext } from 'react';

type AccountContextValue = {
  accountId?: string | null; // Resource ID version of the account
  businessName?: string;
  legacyAccountId?: string | null;
};

export const AccountContext = createContext<AccountContextValue | undefined>(
  undefined
);

export const { Provider } = AccountContext;

export const useAccountContext = () => {
  const context = useContext(AccountContext);
  if (!context) {
    throw new Error(
      'useAccountContext must be used within an AccountContextProvider'
    );
  }
  return context;
};
